(function () {
  'use strict';

  /* Header: transparent over the first photo on the homepage, solid once scrolled */
  var header = document.querySelector('[data-header]');
  var overlay = document.body.classList.contains('has-overlay-header');
  if (header && overlay) {
    var hovering = false;
    var solid = function () {
      var bar = header.querySelector('[data-searchbar]');
      var on = hovering || window.scrollY > 40 || (bar && !bar.hidden);
      header.classList.toggle('is-solid', !!on);
    };
    window.addEventListener('scroll', solid, { passive: true });
    header.addEventListener('mouseenter', function () { hovering = true; solid(); });
    header.addEventListener('mouseleave', function () { hovering = false; solid(); });
    header.addEventListener('click', function () { setTimeout(solid, 0); });
    solid();
  } else if (header) {
    header.classList.add('is-solid');
  }

  /* Banner dots on mobile */
  document.querySelectorAll('[data-nb]').forEach(function (nb) {
    var track = nb.querySelector('[data-nb-track]');
    var dots = nb.querySelectorAll('.nb__dots span');
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
  });

  /* Product sliders: tabs and arrows */
  document.querySelectorAll('[data-ps]').forEach(function (ps) {
    var tabs = ps.querySelectorAll('[data-ps-tab]');
    var tracks = ps.querySelectorAll('[data-ps-track]');
    var alls = ps.querySelectorAll('[data-ps-all]');
    var prev = ps.querySelector('[data-ps-prev]');
    var next = ps.querySelector('[data-ps-next]');
    var current = function () {
      for (var i = 0; i < tracks.length; i++) if (!tracks[i].hidden) return tracks[i];
      return tracks[0];
    };
    var arrows = function () {
      var t = current();
      if (!t || !prev) return;
      prev.disabled = t.scrollLeft <= 4;
      next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    };
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        tracks.forEach(function (t, j) { t.hidden = i !== j; });
        alls.forEach(function (a) { a.hidden = a.getAttribute('data-ps-all') !== String(i + 1); });
        arrows();
      });
    });
    var step = function (dir) {
      var t = current();
      var card = t.querySelector('.card');
      var w = card ? card.getBoundingClientRect().width + 2 : t.clientWidth * .8;
      t.scrollBy({ left: dir * w * Math.max(1, Math.floor(t.clientWidth / w) - 1), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    tracks.forEach(function (t) { t.addEventListener('scroll', arrows, { passive: true }); });
    arrows();
  });

  /* Giant footer wordmark: fit to the page width */
  var fit = document.querySelectorAll('[data-fit]');
  var doFit = function () {
    fit.forEach(function (el) {
      var span = el.firstElementChild;
      if (!span) return;
      el.style.fontSize = '100px';
      var avail = el.clientWidth - 2;
      var w = span.offsetWidth;
      if (w > 0) el.style.fontSize = Math.floor(100 * avail / w) + 'px';
    });
  };
  if (fit.length) {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(doFit);
    doFit();
    window.addEventListener('resize', doFit);
  }
})();
